import axios from "axios";
import { appUrl } from "../../../../../../../utils/config";
import { messagesData } from "./messagesData";

// ============================================================================
// BATCH MESSAGES API - All APIs for Messages / Batch Updates
// ============================================================================

/**
 * Fetch Batch Messages / Updates
 *
 * Backend endpoint (real API - to be enabled later):
 *   POST /{appName}/{network}/{collabType}/{roleName}/batchMessages
 *
 * Example payload (dashboard vs View All will change values):
 * {
 *   "projectId": "AR - LDD",
 *   "batchId": 400682,           // or "all" for View All
 *   "operation": "All",          // or "all" for View All
 *   "viewBy": "Timestamp",       // View All only
 *   "viewByValue": "3",          // View All only (e.g. "3" = Last 3 Days)
 *   "pageSize": 5,
 *   "pageNumber": 1
 * }
 *
 * Expected response structure:
 * {
 *   "status": true,
 *   "data": {
 *     "productName": "Actazosin Step 3",
 *     "cmoName": "Sai Life Sciences",
 *     "batches": [
 *       {
 *         "batchNumber": 400682,
 *         "messages": [ { ...messageFields } ]
 *       }
 *     ],
 *     "totalMessages": 150,
 *     "currentPage": 1,
 *     "totalPages": 30
 *   },
 *   "message": "Batch messages fetched successfully"
 * }
 */
export const fetchMessagesAPI = async (filters = {}) => {
  // ========================= REAL API CALL (COMMENTED) =======================
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const payload = {
  //     projectId: filters.projectId,
  //     batchId: filters.batchId,
  //     operation: filters.operation,
  //     viewBy: filters.viewBy,
  //     viewByValue: filters.viewByValue,
  //     pageSize: filters.pageSize,
  //     pageNumber: filters.pageNumber,
  //   };
  //
  //   const response = await axios.post(`${apiBaseUrl}/batchMessages`, payload);
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching batch messages:", error);
  //   throw error;
  // }
  // ==========================================================================

  // ============================= STATIC MOCK ================================
  // Transform static data to match backend format (grouped by batch number)
  // Backend format: { batches: [{ batchNumber, messages: [{ id, timestamp, messageType, procedureNumber, ...allFields }] }] }
  // All fields are directly on the message object, no nested columns/data object
  const allMessagesFlat = messagesData.batches.flatMap((batch) =>
    batch.messages.map((msg) => ({
      id: msg.id,
      timestamp: msg.timestamp,
      messageType: msg.messageType,
      procedureNumber: msg.procedureNumber,
      batchNumber: batch.batchNumber,
      // Include all other fields directly (not in nested object)
      ...Object.keys(msg).reduce((acc, key) => {
        if (!["id", "timestamp", "messageType", "procedureNumber", "data"].includes(key)) {
          acc[key] = msg[key];
        }
        return acc;
      }, {}),
    }))
  );

  const totalMessages = allMessagesFlat.length;

  const pageNumber = filters.pageNumber || 1;
  const pageSize = filters.pageSize || totalMessages || 1;
  const totalPages = Math.ceil(totalMessages / pageSize);

  // Apply pagination
  const startIndex = (pageNumber - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const pageMessages = allMessagesFlat.slice(startIndex, endIndex);

  // Regroup page messages by batchNumber
  const transformedBatches = pageMessages.reduce((acc, msg) => {
    const existingBatch = acc.find((b) => b.batchNumber === msg.batchNumber);
    if (existingBatch) {
      existingBatch.messages.push(msg);
    } else {
      acc.push({
        batchNumber: msg.batchNumber,
        messages: [msg],
      });
    }
    return acc;
  }, []);

  return {
    status: true,
    data: {
      // Header information (product & CMO)
      productName: "4-(Aminomethyl)-6-bromophthalazin-1(2H)-one (BSQ Stage-C)",
      cmoName: "Sai Life Sciences - Unit-IV",

      // Messages grouped by batch
      batches: transformedBatches,

      // Totals (no separate pagination object)
      totalMessages,
      currentPage: pageNumber,
      totalPages,
    },
    message: "Batch messages fetched successfully (mock)",
  };
};

